import { Component } from '@angular/core';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';
import { RouterLinkActive, RouterLink, RouterOutlet } from '@angular/router';

@Component({
    selector: 'aw-rules-tabs',
    templateUrl: './rules-tabs.component.html',
    styleUrls: ['./rules-tabs.component.less'],
    imports: [MatTabNav, RouterLinkActive, MatTabLink, RouterLink, MatTabNavPanel, RouterOutlet]
})
export class RulesTabsComponent {
}